import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import CtaLinkStyles from '@stories/Components/Buttons/CtaLink/CtaLink.styles';
import Image from '@stories/Components/Misc/Image/Image';
import styled from 'styled-components';
const Container = styled.article `
  --shadowColour: rgba(0, 0, 0, 0.05);

  display: grid;
  grid-template-rows: 1fr auto;
  box-shadow: -0.1px 1px 1.1px var(--shadowColour), -0.2px 2.7px 3px -0.8px var(--shadowColour),
    -0.4px 6.3px 7.1px -1.7px var(--shadowColour), -0.9px 5px 16.9px -2.5px var(--shadowColour);
  border-radius: 10px;
  overflow: hidden;
  height: 100%;
  scroll-margin: var(--scrollOffset, 0px) 0 0;

  &[data-category='lcci-event'] {
    --categoryColor: ${brand.primary.orange};
  }

  &[data-category='lcci-partner'] {
    --categoryColor: ${brand.primary.blue};
  }

  &[data-category='member-run'] {
    --categoryColor: ${brand.tag.press};
  }
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(340, 227)};
`;
const Img = styled(Image) `
  ${imageCoverContainer()};
`;
const Category = styled.div `
  position: relative;
  height: 7px;
  background-color: var(--categoryColor, ${brand.primary.orange});
`;
const CategoryTag = styled.span `
  ${fonts.apparat.semiBold};

  position: absolute;
  top: 50%;
  left: ${fluid(12, 22)};
  transform: translateY(-50%);
  background-color: var(--categoryColor, ${brand.primary.orange});
  color: ${brand.white};
  padding: ${fluid(10, 16)} ${fluid(16, 24)} ${fluid(6, 12)};
  border-radius: 10px;
  font-size: ${fluid(12, 16)};
  text-transform: uppercase;
  white-space: nowrap;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%);
`;
const ContentWrapper = styled.div `
  padding: ${fluid(24, 36)} ${fluid(16, 24)} ${fluid(16, 32)};
  color: ${brand.base.blue};

  ${CtaLinkStyles.Container} {
    margin: ${fluid(0, 20)} 0 0;
    font-size: ${fluid(18, 20)};
    line-height: ${fluid(24, 26)};
  }
`;
const DateTypeWrapper = styled.div `
  ${fonts.apparat.light};

  display: flex;
  align-items: flex-end;
  gap: 40px;
  font-size: ${fluid(12, 16)};
  text-transform: uppercase;
  margin: 0 0 ${fluid(20, 24)};

  > time {
    opacity: 0.5;
    line-height: ${fluid(22, 26)};
    letter-spacing: 0.09em;
  }

  > span {
    background-color: ${brand.primary.blueGrey};
    border-radius: 5px;
    padding: 11px 16px 9px;
  }

  @media ${from(Device.MobileLarge)} {
    gap: 16px;
    align-items: center;
  }
`;
const Title = styled.h3 `
  ${fonts.apparat.semiBold};

  font-size: ${fluid(18, 24)};
  line-height: ${fluid(28, 34)};
  margin: 0 0 24px;

  @media ${from(Device.Tablet)} {
    ${fonts.apparat.medium};
    margin: 0 0 12px;
  }

  + ${CtaLinkStyles.Container} {
    margin: 0;
  }
`;
const Info = styled.div `
  ${paragraphSmall};

  &[data-type='overview'] {
    display: none;

    @media ${from(Device.Tablet)} {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      margin: 0;
    }
  }

  &[data-type='tags'] {
    opacity: 0.5;
    border-top: 1px solid ${brand.secondary.blueGrey};
    margin: ${fluid(18, 22)} 0 0;
    padding: ${fluid(16, 24)} 0 0;
  }
`;
const PastEventListingCardStyles = {
    Container,
    ImageWrapper,
    Img,
    Category,
    CategoryTag,
    ContentWrapper,
    DateTypeWrapper,
    Title,
    Info,
};
export default PastEventListingCardStyles;
